import {ApiResponse} from 'amc-common-components';

/**
 * This class is a helper for api service that provides a methods to map data.
 */
export class ReportApiMapper {
	/**
	 * Static method Map Report Data for mapped data from API response.
	 * @param {ApiResponse<T>} data - param for report data.
	 * @returns {T} - the mapped data for API response.
	 */
	public static mapReportData<T = unknown>(data: ApiResponse<T>): T {
		return data.docs;
	}
}
